// src/services/notificationService.js
import { ref } from "vue";

const notificationMessage = ref("");

export const useNotification = () => {
  const displayNotification = (message) => {
    notificationMessage.value = message;
    setTimeout(() => {
      notificationMessage.value = "";
    }, 3000);
  };

  return { notificationMessage, displayNotification };
};
